// extracted by mini-css-extract-plugin
export default {"button":"FlowLayout_button__ngSr-","container":"FlowLayout_container__lmKnY"};